import {Component, OnInit, Input, OnDestroy, SimpleChanges, OnChanges, Output, EventEmitter} from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { FormValidatorUtils } from '../../../shared/utils';
import { StringUtils } from '../../../shared/utils/src/string.utils';
import { ValidatorUtils } from '../../../shared/utils/src/validator.utils';
import * as _ from 'lodash';
import { DragulaService } from 'ng2-dragula';
@Component({
    selector: 'urgency-rule-component',
    templateUrl: './urgency-rule.component.html'
})

export class UrgencyRuleComponent implements OnInit, OnDestroy, OnChanges  {
    @Input() msgSpecSelectConfig: any;
    @Input() oprTypeSelectConfig: any;
    @Input() urgencyLevelSelectConfig: any;
    @Input() public ruleInfo = [];
    @Input() public isEditable: boolean;
    @Output() public routeNotUse: EventEmitter<any> = new EventEmitter();

    cndVal: string;
    ruleIndex = 0;

    isNullUrgencyCndVal = false;
    isMaxLenUrgencyCndVal = false;

    constructor(private fb: FormBuilder,
                private dragulaService: DragulaService) {

        dragulaService.drop.subscribe((value: any) => {
            if (value[0] === 'incidentUrgencyRule') {
                this.resetOrdrNo();
            }
        });

        dragulaService.setOptions('incidentUrgencyRule', {
            moves: function (el, container, handle) {
                return handle.className === 'dragable_button dragable_flag';
            }
        });

    }

    ngOnInit() {
    }

    ngOnDestroy() {
        this.dragulaService.destroy('incidentUrgencyRule');
    }

    ngOnChanges(changes: SimpleChanges) {
        this.isNullUrgencyCndVal = false;
        this.isMaxLenUrgencyCndVal = false;

        const isEditableChange = changes['isEditable'];

        if (isEditableChange && this.isEditable) {
            if (this.ruleInfo.length === 0) {
                this.ruleSetAdd();
            }
        }
    }

    public ruleSetAdd() {
        this.ruleIndex++;
        this.ruleInfo.push({
            'ordrNo': this.ruleIndex,
            'cndVal': ''
        });

        this.resetOrdrNo();
    }

    public ruleSetRemove(event, ordrNo) {
        _.remove(this.ruleInfo, {ordrNo : ordrNo});

        this.resetOrdrNo();
    }


    public resetOrdrNo() {
        this.ruleIndex = 0;

        this.ruleInfo.forEach((ruleSet, index) => {
            index++;
            ruleSet.ordrNo = index;
            this.ruleIndex = index;
        });

        if (this.ruleIndex === 0) {
            this.routeNotUse.emit('incidentUrgency');
        }
    }

    public getRuleInfo(): any {
        const _urgencyRuleInfo = [];
        let maxOrdrNo = 0;
        $('#incidentUrgency tbody tr').each(function (_index) {
            const urgencyRule = {
                ordrNo: _index + 1,                                                 //룰셋팅 순번
                cndCnnTypeCd: _index === 0 ? 'RUCDCN10' : 'RUCDCN20',               //첫번째룰은 if 두번째룰은 else if
                msgSpecFildNo: $(this).find('#msgSpecList option:selected').val(),
                oprTypeCd: $(this).find('#oprTypeList option:selected').val(),
                cndVal: $(this).find('#UrgencyCndVal').val(),
                cndValAryYn: 'N',
                cndValSprtnChaVal: '',
                routTrgtNo: $(this).find('#urgencyLevelList option:selected').val()
            };
            maxOrdrNo = _index + 1;
            _urgencyRuleInfo.push(urgencyRule);
        });

        _urgencyRuleInfo.push({
            ordrNo: maxOrdrNo + 1,                                         //룰셋팅 순번
            cndCnnTypeCd: 'RUCDCN30',
            msgSpecFildNo: 0,
            oprTypeCd: '-',
            cndVal: '-',
            cndValAryYn: 'N',
            cndValSprtnChaVal: '',
            routTrgtNo: $('#defaultUrgencyLevelList option:selected').val()
        });

        return _urgencyRuleInfo;
    }

    public validation() {
        this.isNullUrgencyCndVal = false;

        let urgencyValidation = true;
        this.ruleInfo.forEach((ruleSet, index) => {
            if (StringUtils.isEmpty(ruleSet.cndVal)) {
                ruleSet.isInvalid = true;
                ruleSet.isNullCndVal = true;
                ruleSet.isMaxLenCndVal = false;

                urgencyValidation = false;
            } else if (StringUtils.checkMaxStr(ruleSet.cndVal, 200)) {
                ruleSet.isInvalid = true;
                ruleSet.isNullCndVal = false;
                ruleSet.isMaxLenCndVal = true;

                urgencyValidation = false;

            } else {
                ruleSet.isInvalid = false;
                ruleSet.isNullCndVal = false;
                ruleSet.isMaxLenCndVal = false;
            }
        });

        if ($('#defaultUrgencyLevelList option:selected').val() === '') {
            urgencyValidation = false;
        }

        return urgencyValidation;
    }

    public getRuleInfoLength() {
        return this.ruleInfo.length;
    }

    urgencyCngValChanged(ruleSet) {
        if (StringUtils.isEmpty(ruleSet.cndVal)) {
            ruleSet.isInvalid = true;
        } else {
            ruleSet.isInvalid = false;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/ruleSet/urgency-rule/urgency-rule.component.ts